'use client'
import heroImage from 'assets/blogs/HeroImage.svg'
import {heroSectionData} from 'content/blog'
import Image from 'next/image'
import {usePathname, useRouter, useSearchParams} from 'next/navigation'
import * as React from 'react'
import Navigation from 'v1/common-components/navigation/Navigation'
import DebouncedInput from '../debounced-input/DebouncedInput'
import classes from './styles.module.css'

export default function BlogHero() {
  const router = useRouter()
  const searchParams = useSearchParams()
  const pathname = usePathname()

  const handleSearch = React.useCallback(
    (text: string) => {
      if (text.trim()) {
        // Navigate to search results
        router.push(`/blogs?search=${encodeURIComponent(text.trim())}`, {scroll: false})
      } else {
        // If search is empty, navigate to clean blogs page
        router.push('/blogs', {scroll: false})
      }
    },
    [router],
  )

  return (
    <div className={classes.container}>
      <div className={classes.subContainer}>
        <Navigation />
        <div className={classes.content}>
          <div className={classes.textPlusSearch}>
            <div className={classes.text}>
              <h2 className={classes.header}>{heroSectionData.title}</h2>
              <p className={classes.desc}>{heroSectionData.desc}</p>
            </div>
            <DebouncedInput
              onSearch={handleSearch}
              debounceMs={500} // Shorter debounce for better UX
              immediate={false}
              serverSide={false}
            />
          </div>
          <div className={classes.heroImageSection}>
            <Image src={heroImage} alt="cookie" className={classes.cookieImg} />
          </div>
        </div>
      </div>
    </div>
  )
}
